export enum CommentType {
  Comment,
  Reply,
}
